import { useQuery } from '@tanstack/react-query';
import { OrganizationApi } from '../../api/organization/organization.api';

interface Params {
  currentUserOrganizations: string[];
}

interface Options {
  staleTime?: number;
}

export const useFetchChildOrganizations = (
  { currentUserOrganizations }: Params,
  options?: Options,
) => {
  const fetchUrl = `organization/child`;

  return useQuery({
    enabled: true,
    queryKey: ['childOrganizations', `/${fetchUrl}`, currentUserOrganizations],
    queryFn: () => OrganizationApi.getChildOrganizations({ currentUserOrganizations }),
    staleTime: options?.staleTime,
  });
};
